import { Provider } from '@angular/core';

import { GetAllChatTypeUseCase } from '@application/use-cases/chat-settings/get-all-chat-type.use-case';
import { GetArchivedSectorsUseCase } from '@application/use-cases/chat-settings/get-archived-sectors.use-case';
import { GetChatChannelConfigUseCase } from '@application/use-cases/chat-settings/get-chat-channel-config.use-case';
import { GetConfigDetailUseCase } from '@application/use-cases/chat-settings/get-config-detail.use-case';
import { SearchUserUseCase } from '@application/use-cases/chat-settings/search-user.use-case';
import { SwitchArchiveSectorUseCase } from '@application/use-cases/chat-settings/switch-archive-sector.use-case';
import { UpdateChatChannelConfigUseCase } from '@application/use-cases/chat-settings/update-chat-channel-config.use-case';
import { UpdateConfigUseCase } from '@application/use-cases/chat-settings/update-config.use-case';

import { ChatSettingsRepository } from '@domain/repositories/chat-settings.repository';

import {
  GetApplicableSectorUseCase,
  UpdateChatSettingsUseCase,
} from '@app/application';
import { GetChatSettingsUseCase } from '@app/application/use-cases/chat-settings/get-chat-settings.use-case';
import { ChatSettingsRepositoryImpl } from '../repositories/chat-settings.repository.impl';

export const CHAT_SETTINGS_PROVIDERS: Provider[] = [
  {
    provide: ChatSettingsRepository,
    useClass: ChatSettingsRepositoryImpl,
  },
  {
    provide: GetAllChatTypeUseCase,
    useFactory: (chatSettingsRepo: ChatSettingsRepository) =>
      new GetAllChatTypeUseCase(chatSettingsRepo),
    deps: [ChatSettingsRepository],
  },
  {
    provide: GetChatChannelConfigUseCase,
    useFactory: (chatSettingsRepo: ChatSettingsRepository) =>
      new GetChatChannelConfigUseCase(chatSettingsRepo),
    deps: [ChatSettingsRepository],
  },
  {
    provide: GetConfigDetailUseCase,
    useFactory: (chatSettingsRepo: ChatSettingsRepository) =>
      new GetConfigDetailUseCase(chatSettingsRepo),
    deps: [ChatSettingsRepository],
  },
  {
    provide: UpdateChatChannelConfigUseCase,
    useFactory: (chatSettingsRepo: ChatSettingsRepository) =>
      new UpdateChatChannelConfigUseCase(chatSettingsRepo),
    deps: [ChatSettingsRepository],
  },
  {
    provide: UpdateConfigUseCase,
    useFactory: (chatSettingsRepo: ChatSettingsRepository) =>
      new UpdateConfigUseCase(chatSettingsRepo),
    deps: [ChatSettingsRepository],
  },
  {
    provide: GetArchivedSectorsUseCase,
    useFactory: (chatSettingsRepo: ChatSettingsRepository) =>
      new GetArchivedSectorsUseCase(chatSettingsRepo),
    deps: [ChatSettingsRepository],
  },
  {
    provide: SwitchArchiveSectorUseCase,
    useFactory: (chatSettingsRepo: ChatSettingsRepository) =>
      new SwitchArchiveSectorUseCase(chatSettingsRepo),
    deps: [ChatSettingsRepository],
  },
  {
    provide: SearchUserUseCase,
    useFactory: (chatSettingsRepo: ChatSettingsRepository) =>
      new SearchUserUseCase(chatSettingsRepo),
    deps: [ChatSettingsRepository],
  },
  {
    provide: GetChatSettingsUseCase,
    useFactory: (chatSettingsRepo: ChatSettingsRepository) =>
      new GetChatSettingsUseCase(chatSettingsRepo),
    deps: [ChatSettingsRepository],
  },
  {
    provide: UpdateChatSettingsUseCase,
    useFactory: (chatSettingsRepo: ChatSettingsRepository) =>
      new UpdateChatSettingsUseCase(chatSettingsRepo),
    deps: [ChatSettingsRepository],
  },
  {
    provide: GetApplicableSectorUseCase,
    useFactory: (chatSettingsRepo: ChatSettingsRepository) =>
      new GetApplicableSectorUseCase(chatSettingsRepo),
    deps: [ChatSettingsRepository],
  },
];
